// extracted by mini-css-extract-plugin
export default {"loader-skeleton":"LoaderSkeleton_loader-skeleton__-hnlu"};